import React, { useEffect, useState } from "react";
import { Modal, Radio } from "antd";
import { AutoResizeTextArea } from "../../../components/AutoResizeTextArea";
import { BlockReason, BlockingDecisionBasedOn } from "../../../models";
import styles from "./reasonPickerModal.scss";

interface ReasonPickerModalProps {
  visible: boolean;
  title: string;
  reasons: BlockReason[];
  submitText?: string;
  cancelText?: string;
  commentPlaceholder?: string;
  onConfirm: (reasonId: number, note: string, basedOn: number) => void;
  onCancel: () => void;
  loading?: boolean;
}

const ReasonPickerModal = (props: ReasonPickerModalProps) => {
  const {
    visible,
    title,
    reasons,
    submitText,
    cancelText,
    commentPlaceholder,
    onConfirm,
    onCancel,
    loading
  } = props;

  const [reasonId, setReasonId] = useState(null);
  const [basedOn, setBasedOn] = useState(null);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [basedOnError, setBasedOnError] = useState("");
  const [commentError, setCommentError] = useState("");

  useEffect(() => {
    if (!visible) return;
    setReasonId(null);
    setBasedOn(null);
    setComment("");
    setError("");
    setBasedOnError("");
    setCommentError("");
  }, [visible]);

  const handleOk = () => {
    let hasError = false;
    if (reasonId == null) {
      setError("Odaberite razlog.");
      hasError = true;
    }
    if (basedOn == null) {
      setBasedOnError("Odaberite osnovu za odluku.");
      hasError = true;
    }
    const trimmedComment = comment.trim();
    if (!trimmedComment) {
      setCommentError("Unesite obrazloženje odluke.");
      hasError = true;
    }
    if (hasError) return;
    onConfirm(reasonId, trimmedComment, basedOn);
  };

  const handleReasonChange = (e: any) => {
    setReasonId(e.target.value);
    if (error) setError("");
  };

  const handleBasedOnChange = (e: any) => {
    setBasedOn(e.target.value);
    if (basedOnError) setBasedOnError("");
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText={submitText || "Spremi"}
      cancelText={cancelText || "Odustani"}
      confirmLoading={loading}
      width={640}
      // @ts-ignore antd v3 Modal accepts centered but the typing here is stale
      centered
      destroyOnClose
    >
      <Radio.Group
        value={reasonId}
        onChange={handleReasonChange}
        className={styles.reasonList}
      >
        {reasons.map(r => (
          <Radio key={r.id} value={r.id} className={styles.reasonItem}>
            {r.name}
          </Radio>
        ))}
      </Radio.Group>
      {error && <div className={styles.fieldError}>{error}</div>}
      <div className={`${styles.commentLabel} required`}>Odluka je donesena na temelju:</div>
      <Radio.Group
        value={basedOn}
        onChange={handleBasedOnChange}
        className={styles.reasonList}
      >
        <Radio value={BlockingDecisionBasedOn.userReport} className={styles.reasonItem}>
          {"Prijave korisnika"}
        </Radio>
        <Radio value={BlockingDecisionBasedOn.internalCheck} className={styles.reasonItem}>
          {"Vlastite provjere Index Oglasa"}
        </Radio>
      </Radio.Group>
      {basedOnError && <div className={styles.fieldError}>{basedOnError}</div>}
      <div className={`${styles.commentLabel} required`}>Obrazloženje odluke</div>
      <AutoResizeTextArea
        value={comment}
        onChange={e => {
          setComment(e.target.value);
          if (commentError) setCommentError("");
        }}
        placeholder={commentPlaceholder || "Unesite obrazloženje odluke…"}
        rows={3}
      />
      {commentError && <div className={styles.fieldError}>{commentError}</div>}
    </Modal>
  );
};

export default ReasonPickerModal;



// WEBPACK FOOTER //
// ./src/routes/Admin/ReasonPickerModal/ReasonPickerModal.tsx